import React, { FC } from "react";
import { BadgeProps as MuiBadgeProps, Badge as MuiBadge } from "@mui/material";
import { styled } from "@mui/material/styles";

export interface BadgeProps extends MuiBadgeProps {
  color: "primary" | "secondary";
}

const StyledMuiBadge = styled(MuiBadge)`
  & .MuiBadge-badge.MuiBadge-dot {
    z-index: 0;
  }
`;

export const Badge: FC<BadgeProps> = ({ children, ...props }) => {
  return <StyledMuiBadge {...props}>{children}</StyledMuiBadge>;
};

export default Badge;
